import { z } from 'zod';
import { ChannelSchema, ProductGroupSchema } from './customer';

export const HistoricalOrderSchema = z.object({
  id: z.string(),
  warehouse_id: z.string(),
  customer_id: z.string(),
  date: z.string(), // YYYY-MM-DD
  qty: z.number().int().nonnegative(),
  // Optional breakdowns — null if not available in source data
  channel: ChannelSchema.nullable().default(null),
  product_group: ProductGroupSchema.nullable().default(null),
  source: z.enum(['IMPORT_XLSX', 'IMPORT_API', 'MANUAL_ENTRY', 'BACKFILL']).default('IMPORT_XLSX'),
  imported_at: z.string(),
  imported_by: z.string(),
});
export type HistoricalOrder = z.infer<typeof HistoricalOrderSchema>;
